/** Improve readability when DB stores rules in ALL CAPS. */
export function formatPolicyText(text) {
  const value = String(text ?? "").trim();
  if (!value) return "";

  const alpha = value.replace(/[^A-Za-z]/g, "");
  if (alpha.length < 6 || alpha !== alpha.toUpperCase()) {
    return value;
  }

  return value
    .split(/(?<=[.!?])\s+/)
    .map((part) => {
      const p = part.trim();
      if (!p) return "";
      return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    })
    .filter(Boolean)
    .join(" ");
}
